module.exports = __webpack_public_path__ + "img/logoGun.8e34a0cb.png";